import { QueryClient } from '@tanstack/react-query'

// Create a query client with ETag-aware caching
// SECURITY: In-memory cache is safe because it's cleared on page reload (new login)
// ETags prevent unnecessary network requests when data hasn't changed
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache data for 5 minutes by default - works with ETag validation
      staleTime: 5 * 60 * 1000,
      // Keep data in cache for 10 minutes
      gcTime: 10 * 60 * 1000,
      // Retry failed requests 3 times with exponential backoff
      retry: (failureCount: number, error: Error & { response?: { status?: number } }) => {
        // Don't retry on 4xx errors (client errors)
        if (error?.response?.status && error.response.status >= 400 && error.response.status < 500) {
          return false
        }
        // Retry up to 3 times for network errors or 5xx errors
        return failureCount < 3
      },
      // Retry delay with exponential backoff
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      // Don't refetch on window focus in development
      refetchOnWindowFocus: process.env.NODE_ENV === 'production',
      // Refetch on reconnect for network recovery
      refetchOnReconnect: true,
      // Don't automatically refetch in background by default
      refetchInterval: false
    },
    mutations: {
      // Retry mutations once
      retry: 1
    }
  }
})

// Query key factory for consistent cache keys
export const queryKeys = {
  // Contracts
  contracts: () => ['contracts'] as const,

  // Power data with contract and months
  powerData: (contrato: string, ano: string, mes: string, months: number) =>
    ['power-data', contrato, ano, mes, months] as const,

  // Daily consumption data
  consumption: (contrato: string, ano: string, mes: string, dia: string) =>
    ['consumption', contrato, ano, mes, dia] as const
}

